import { takeLatest, put, call } from "redux-saga/effects"
import { normalize } from "normalizr"
import { displayUserMessageAction } from "../../../userMessage/state/userMessageActions"
import { withAuthHeader } from "../../../../apis/contextmeeting/withAuthHeader"
import API from "../../../../apis/contextmeeting/api"
import { assetsSchema } from "../../../../apis/contextmeeting/schema"
import { CaseSharedAssetsActionTypes, IDeleteCaseSharedAssetAsyncAction } from "../caseSharedAssetsTypes"
import { UserMessageTypes } from "../../../userMessage/state/userMessageTypes"

export function* deleteCaseSharedAssetAsync(action: IDeleteCaseSharedAssetAsyncAction): Generator {
  try {
    const caseId = action.payload.caseId
    const userSharedAssetId = action.payload.userSharedAssetId
    const userId = action.payload.userId

    const response: any = yield call(API.delete, `/cases/${caseId}/shared_assets/${userSharedAssetId}`, withAuthHeader())

    const normalizedResponse = normalize(response.data.all, [assetsSchema])

    yield put({
      type: CaseSharedAssetsActionTypes.DELETE_CASE_SHARED_ASSET_ASYNC_SUCCESS,
      payload: {
        all: normalizedResponse,
        caseId: caseId,
        userId: userId
      }
    })

    yield put(displayUserMessageAction({
      messageKey: "deleteCaseSharedAssetSuccess",
      type: UserMessageTypes.SUCCESS
    }))

  } catch (error) {
    yield put({
      type: CaseSharedAssetsActionTypes.DELETE_CASE_SHARED_ASSET_ASYNC_ERROR,
      payload: error
    })

    yield put(displayUserMessageAction({
      messageKey: "deleteCaseSharedAssetFail",
      type: UserMessageTypes.ERROR
    }))
  }
}

export function* watchDeleteCaseSharedAssetAsync(): Generator {
  yield takeLatest(CaseSharedAssetsActionTypes.DELETE_CASE_SHARED_ASSET_ASYNC_PENDING, deleteCaseSharedAssetAsync)
}
